<div class="content dark">
	<div class="row">
		<div class="col-lg-6">
			<div class="form-group">
				<label>Create from Template:</label>
				<select [(ngModel)]="selectedTemplate" [disabled]="assetconfig" (ngModelChange)="templateChange($event)" class="form-control">
					<option *ngFor="let template of templates" [ngValue]="template">{{template.description}}</option>
				</select>
				<div *ngIf="loaderrormessage" class="message-bad">{{loaderrormessage}}</div>
			</div>
		</div>
	</div>
	<ng-container *ngIf="userinputgroups && !assetconfig">
		<div class="row">
			<div class="col-lg-8">
				<div *ngFor="let section of userinputgroups" class="item-panel">
					<div *ngIf="section.description" class="heading">{{section.description}}</div>
					<div class="content">
						<div *ngFor="let token of section.tokens" class="row token-input">
							<div class="col-sm-6">
								<label>{{token.description}}</label>
							</div>
							<div class="col-sm-6">
								<input *ngIf="token.type === 'string'" [(ngModel)]="token.value" type="text" maxlength="50" class="form-control token-string">
								<input *ngIf="token.type === 'stringempty'" [(ngModel)]="token.value" type="text" maxlength="50" class="form-control token-stringempty">
								<input *ngIf="token.type === 'number'" [(ngModel)]="token.value" type="number" step="any" class="form-control token-number">
								<input *ngIf="token.type === 'int'" [(ngModel)]="token.value" type="number" step="1" class="form-control token-int">
								<input *ngIf="token.type === 'period'" [(ngModel)]="token.value" type="text" pattern="\d*[MH]" class="form-control token-period">
								<input *ngIf="token.type === 'ver'" [(ngModel)]="token.value" type="text" pattern="\d*\.\d*\.\d*" class="form-control token-ver">
								<select *ngIf="token.type === 'sampcode'" [(ngModel)]="token.value" class="form-control token-sampcode">
									<option *ngFor="let code of token.allowedCodes">{{code}}</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-8">
				<app-action-button [action]="GenerateConfig" [context]="this" processing="Generating..." complete="Config added">Generate
					asset config</app-action-button>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="assetconfig">
		<div class="row">
			<div class="col-lg-8">
				<label>XML configuration result:</label>
				<textarea [(ngModel)]="assetconfig" class="config-area"></textarea>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-8">
				<div class="form-group">
					<label>Organization to assign configuration to:</label>
					<select [(ngModel)]="selectedOrganization" class="form-control">
						<option *ngFor="let org of organizations" [ngValue]="org">{{org.name}}</option>
					</select>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-8">
				<div class="row">
					<div class="col-sm-6 col-lg-5 col-xl-4">
						<div class="form-group">
							<button (click)="GoBack()" class="btn btn-block btn-info">&lt; Go back</button>
						</div>
					</div>
					<div class="col-sm-6 col-lg-5 offset-lg-2 col-xl-4 offset-xl-4">
						<app-action-button [action]="SaveConfig" [disabled]="!selectedOrganization" [context]="this" processing="Saving..."
						 complete="Config saved" btnClass="btn-success btn-block">Save to
							new asset config</app-action-button>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>